(function($) {
    const filterMeetings = function() {
        const meetings = $('#meetings-list li')

        // Get list of selected units.
        const unitCheckboxes = $('#meetings-filter-form .unit-checkbox')
        const selectedUnits = []

        unitCheckboxes.each(function() {
            if(this.checked) {
                selectedUnits.push(this.value)
            }
        })

        //
        const attending = $('#meetings-filter-form #attending')[0]
        const serving = $('#meetings-filter-form #serving')[0]

        const gradeCheckboxes = $('#meetings-filter-form .grade')
        let selectedGrades = []

        gradeCheckboxes.each(function() {
            if(this.checked) {
                selectedGrades.push(this.value)
            }
        })

        const myGrades = $('#meetings-filter-form #my-grades')[0]

        if (!selectedGrades.length && myGrades.checked) {
            selectedGrades = myGrades.value.split(' ')
        }

        const today = $('#meetings-filter-form #today')[0]
        const thisWeek = $('#meetings-filter-form #this-week')[0]
        const dateFrom = $('#meetings-filter-form #date-from')[0]
        const dateTo = $('#meetings-filter-form #date-to')[0]

        // Loop over each meeting and set its hidden attribute.
        meetings.each(function() {
            let validUnit = true
            if (selectedUnits.length) {
                const meetingUnit = this.getAttribute('data-unit')
                const meetingDivision = this.getAttribute('data-division')
                validUnit = selectedUnits.includes(meetingUnit) || selectedUnits.includes(meetingDivision)
            }

            let validAttending = true
            if (attending && attending.checked) {
                const meetingAttending = this.getAttribute('data-attending')
                validAttending = [true, 'true', 1, '1'].includes(meetingAttending)
            }

            let validServing = true
            if (serving && serving.checked) {
                const meetingServing = this.getAttribute('data-serving')
                validServing = [true, 'true', 1, '1'].includes(meetingServing)
            }

            let validGrade
            if(selectedGrades.length) {
                const meetingGrades = this.getAttribute('data-grades').split(' ')
                let found = false
                for(const meetingGrade of meetingGrades) {
                    if (selectedGrades.includes(meetingGrade)) {
                        found = true
                        break
                    }
                }
                validGrade = found
            } else {
                validGrade = true
            }

            let validDate = true
            const meetingDate = this.getAttribute('data-date')
            const meetingMilliseconds = new Date(meetingDate)
            if (today.checked) {
                validDate = meetingDate === today.value
            } else if (thisWeek.checked) {
                const weekFrom = +(new Date(today.value))
                const weekTo = +(new Date(today.value)) + (7 * 24 * 60 * 60 * 1000)
                validDate = meetingMilliseconds >= weekFrom && meetingMilliseconds <= weekTo
            } else if(dateFrom.value || dateTo.value) {
                let validFrom = true
                let validTo = true

                if (dateFrom.value) {
                    const fromMilli = +(new Date(dateFrom.value))
                    validFrom = meetingMilliseconds >= fromMilli
                }

                if (dateTo.value) {
                    const toMilli = +(new Date(dateTo.value))
                    validTo = meetingMilliseconds <= toMilli
                }

                validDate = validFrom && validTo
            }

            if (validUnit && validAttending && validServing && validGrade && validDate) {
                this.removeAttribute('hidden')
            } else {
                this.setAttribute('hidden', true)
            }
        })

        if ($('#meetings-list li:hidden').length === meetings.length) {
            $('#no-match').attr('hidden', false)
        } else {
            $('#no-match').attr('hidden', true)
        }
    }

    const resetGrades = function () {
        $('#meetings-filter-form .grade').prop('checked', false)
    }

    const resetMyGrades = function () {
        $('#meetings-filter-form #my-grades').prop('checked', false)
    }

    const resetWeekPeriod = function () {
        $('#meetings-filter-form #this-week').prop('checked', false)
        $('#meetings-filter-form #date-from').val('')
        $('#meetings-filter-form #date-to').val('')
    }

    const resetTodayPeriod = function () {
        $('#meetings-filter-form #today').prop('checked', false)
        $('#meetings-filter-form #date-from').val('')
        $('#meetings-filter-form #date-to').val('')
    }

    const resetTodayWeek = function () {
        $('#meetings-filter-form #today').prop('checked', false)
        $('#meetings-filter-form #this-week').prop('checked', false)
    }

    $(document).ready(function() {
        const body = $('body')

        body.on('change', '#meetings-filter-form input', filterMeetings)
        body.on('change', '#meetings-filter-form #my-grades', resetGrades)
        body.on('change', '#meetings-filter-form .grade', resetMyGrades)
        body.on('change', '#meetings-filter-form #today', resetWeekPeriod)
        body.on('change', '#meetings-filter-form #this-week', resetTodayPeriod)
        body.on('change', '#meetings-filter-form input.period', resetTodayWeek)

    })
})(window.jQuery);
